// extracted by mini-css-extract-plugin
module.exports = {"descriptionTitle":"InputField_descriptionTitle__3WVE8","description":"InputField_description__1tTQj","sliderDescription":"InputField_sliderDescription__3DNUP"};